import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
import ShareLink from 'modules/deep-linking/deep-linking';
import {CalculatorsPage} from 'modules/report/components/report-components/therapeutic-adjustment/calculators';

const EditPatientInfo = lazy(() =>
  import('modules/report/pages/edit-patient-info')
);
const DashboardPage = lazy(() => import('modules/home/pages/dashboard'));
const ReportPage = lazy(() =>
  import('modules/report/pages/patient-report-page')
);
const ScanPage = lazy(() => import('modules/scan/scan'));
const ProfilePage = lazy(() => import('modules/user/pages/profile'));
const ListPage = lazy(() => import('modules/patient-list/pages/patient-list'));
const FaqPage = lazy(() => import('modules/faq/pages/index'));
const SupportPage = lazy(() => import('modules/support/index'));
const NotificationPage = lazy(() => import('modules/notification/pages/notification-page'));

export const appRoutes = [
  {
    name: 'home',
    route: '/home',
    component: <DashboardPage />
  },
  {
    name: 'profile',
    route: `/profile`,
    component: <ProfilePage />
  },
  {
    name: 'report',
    route: '/report',
    component: <ReportPage />
  },
  {
    name: 'shareLink',
    route: '/share/:id',
    component: <ShareLink />
  },
  {
    name: 'edit',
    route: `/edit`,
    component: <EditPatientInfo />
  },

  {
    name: 'list',
    route: `/list`,
    component: <ListPage />
  },
  {
    name: 'scan',
    route: `/scan`,
    component: <ScanPage />
  },
  {
    name: 'notification',
    route: `/notification`,
    component: <NotificationPage />
  },
  {
    name: 'faq',
    route: `/faq`,
    component: <FaqPage />
  },
  {
    name: 'support',
    route: `/support`,
    component: <SupportPage />
  },
  {
    name: 'home',
    route: `/*`,
    component: <Navigate to="home" />
  },
  {
    name: 'calculator',
    route: `/report/calculator`,
    component: <CalculatorsPage />
  }
];
